































import { Component, Vue } from "vue-property-decorator";
import {
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId,
  getCurrentEmployee
} from "@/plugins/roles";
import HomePageCompanyOwner from "@/components/home-page/HomePageCompanyOwner.vue";
import HomePageContentManager from "@/components/home-page/HomePageContentManager.vue";
import HomePageDocumentRequestManager from "@/components/home-page/HomePageDocumentRequestManager.vue";
import HomePageListener from "@/components/home-page/HomePageListener.vue";

@Component({
  components: {
    HomePageListener,
    HomePageCompanyOwner,
    HomePageContentManager,
    HomePageDocumentRequestManager
  }
})
export default class Home extends Vue {
  get listener() {
    return !this.currentEmployee && !this.selectCompanyId;
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get selectCompanyId() {
    return getCurrentCompanyId();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwnerInStore() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.currentEmployee?.roles.includes("content_manager");
  }

  get documentManager() {
    return this.currentEmployee?.roles.includes("document_manager");
  }

  get learningRequestManager() {
    return this.currentEmployee?.roles.includes("learning_request_manager");
  }

  get root() {
    return isRoot();
  }

  get vuexCompany() {
    return (
      !!this.$store.getters?.selectedCompany?.id ||
      this.$store.getters?.userIsEmployee
    );
  }

  mounted() {
    if (!this.vuexCompany) {
      this.$router.push({ name: "courses" });
    }
  }
}
